import { useState } from 'react';
import { FoldPanel } from '@src/components';
import { ParticipantFace } from '@src/components/faces/ParticipantFace';
import { avatarFrames } from '@src/components/faces/wizardAvatarFrame';
import type { FrameDecoration } from '@src/components/faces/AvatarFrameDecoration';
import './AvatarFramesSection.css';

export function AvatarFramesSection() {
  const [decoration, setDecoration] = useState<FrameDecoration>('stars');
  const [animal, setAnimal] = useState('bear');
  return (
    <FoldPanel
      id="avatar-frames"
      title="Approved avatar frames"
      hint="The ten approved frames, rendered with the shared production avatar component."
    >
      <div className="avatar-frames-review__controls">
        <label>
          Backdrop{' '}
          <select
            aria-label="Frame decorations"
            value={decoration}
            onChange={(event) => setDecoration(event.target.value as FrameDecoration)}
          >
            <option value="plain">Plain</option>
            <option value="stars">Shining stars</option>
            <option value="falling">Falling items</option>
          </select>
        </label>
        <label>
          Animal{' '}
          <select
            aria-label="Frame animal"
            value={animal}
            onChange={(event) => setAnimal(event.target.value)}
          >
            {[
              'bear',
              'sloth',
              'koala',
              'fox',
              'cat',
              'rabbit',
              'panda',
              'owl',
              'deer',
              'penguin',
            ].map((name) => (
              <option key={name}>{name}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="avatar-frames-review__grid">
        {avatarFrames.map((frame) => (
          <article key={frame.name} data-gallery-id={frame.galleryId}>
            <h3>{frame.galleryId}</h3>
            <div className="avatar-frames-review__large">
              <ParticipantFace
                picture={animal}
                frameName={frame.name}
                decoration={decoration}
                size="round"
              />
            </div>
            <div className="avatar-frames-review__small">
              <ParticipantFace picture={animal} frameName={frame.name} decoration={decoration} />
            </div>
          </article>
        ))}
      </div>
    </FoldPanel>
  );
}
